export enum QueryKey {
  REZEPT_SUCHE = "rezepte-suche",
  REZEPT_DETAIL = 'rezept-detail'
}

export enum LocalStorageKey {
  REZEPT_EDIT = 'REZEPT_EDIT',
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
  REZEPT_HISTORY = 'REZEPT_HISTORY',
  COOKIES_ACCEPTED = 'COOKIES_ACCEPTED',
}

